import { Plugin, PluginKey } from 'prosemirror-state'
import { QueryClient } from 'react-query'
import { IStackManager } from 'almanac-ui/Modal/Types'
import { EditorView } from 'prosemirror-view'
import { AIPromptBarView } from './AIPromptBarView'
import { DocStore } from 'stores/DocStore'
import { showPersistentToastMessage } from 'blaze-components/PersistentToast/ShowPersistentToastMessage'
import { WizardType } from 'components/Wizards/schemas/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { TextSelect } from 'blaze-ui/icons/32'
import Breakpoints from 'utils/breakpoints.module.scss'
import { Plus } from 'blaze-ui/icons'
import { TurnInto } from 'blaze-ui/icons/36'
import Styles from './AIPromptBar.module.scss'
import { showRateGenerationToast } from 'screens/ProseEdit/components/RateGenerationToast/showRateGenerationToast'

export const AIPromptBarPluginKey = new PluginKey('AIPromptBar')

export type AIPromptBarPluginState = {
  stackManager: IStackManager
  articleId: string
  layerId: string
  channel?: WizardType
  queryClient: QueryClient
  docStore: DocStore
}

export function AIPromptBarPlugin({
  stackManager,
  articleId,
  layerId,
  queryClient,
  docStore,
  channel,
}: AIPromptBarPluginState) {
  return new Plugin({
    key: AIPromptBarPluginKey,
    state: {
      init: (_): AIPromptBarPluginState => {
        return {
          stackManager,
          articleId,
          layerId,
          channel,
          queryClient,
          docStore,
        }
      },
      apply: (tr, pluginState: AIPromptBarPluginState): AIPromptBarPluginState => {
        const articleGenerationCompleted = tr.getMeta('generation_complete')
        const width = window.visualViewport?.width || window.innerWidth
        const isMobile = width <= parseInt(Breakpoints.phoneMaxWidth)

        if (articleGenerationCompleted) {
          if (
            !isMobile &&
            (!channel || [GenerationType.Brainstorm, GenerationType.ContentPlan].includes(channel as GenerationType))
          ) {
            showPersistentToastMessage({
              showCloseButton: true,
              closeOnNavigationChange: true,
              icon: (
                <div className={Styles.turnIntoIcon}>
                  <TextSelect />
                  <Plus />
                  <TurnInto size={32} />
                </div>
              ),
              message:
                'Highlight an idea and select "Turn Into" in the right-hand toolbar to transform it into social content, blogs, emails, and more!',
            })
          } else {
            showRateGenerationToast({ generationId: articleGenerationCompleted, theme: 'dark' })
          }
        }
        return { ...pluginState }
      },
    },
    view: (view: EditorView) => {
      return new AIPromptBarView(view)
    },
  })
}
